import Holder from "../../Components/HOC/Holder";
import CustomBtn from "../../Components/Reusable/CustomBtn";
import TableReusable from "../../Components/Reusable/TableReusable";
import { useNavigate } from "react-router-dom";
import { Box, Stack } from "@mui/system";
import FilterStream from "../../Components/PopUp/FilterStream";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

import {
  popupState,
  selectedStreamState,
  streamState,
} from "../../Recoil/RecoilState";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { baseURL, streamColumns } from "../../utils/StaticVariables";
import useFetchStreams from "../../hooks/useFetchStreams";
import axios from "axios";
import { authState } from "../../Recoil/RecoilState";
import { useSnackbar } from "notistack";
import { useEffect, useRef, useState } from "react";
import DesBtn from "../../Components/Reusable/DesBtn";

const Streams = () => {
  // const { data, loading } = useRecoilValue(streamState);

  const [selectedData, setSelectedStream] = useRecoilState(selectedStreamState);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const setPopup = useSetRecoilState(popupState);
  const navigate = useNavigate();
  // const { refetchStreams } = useFetchStreams(); // Destructure the hook
  const { token } = useRecoilValue(authState);
  const { enqueueSnackbar } = useSnackbar();
 
  useEffect(() => {

    setSelectedStream([]);
  }, [data, setSelectedStream]); //

  // ⬇️ Handle checkbox selection
  const changeSelectDataRow = (selectedNewData) => {
    const isInSelectedData = selectedData.some(
      (el) => el.id === selectedNewData.id
    );
    setSelectedStream(
      isInSelectedData
        ? selectedData.filter((el) => el.id !== selectedNewData.id)
        : [...selectedData, selectedNewData]
    );
  };

  const handelDeleteReqFromApi = async () => {
    const selectedIDs = selectedData?.map((el) => el.id);
    try {
      await axios.delete(`${baseURL}source`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          ids: selectedIDs,
        },
      });
      setSelectedStream([]);
      searchLocationsAPI(filter); //  Refresh list after deletion
      enqueueSnackbar("Stream deleted successfully", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar("Delete failed " + error?.message, {
        variant: "error",
      });
    }
  };

  const [filter, setFilter] = useState({});
  const childRef = useRef(null);

  // دالة لاستدعاء API البحث عن المواقع
  const searchLocationsAPI = async (filterData) => {
    try {
      // إعداد query parameters
      const params = new URLSearchParams();
      setLoading(true);
      // البحث عن آخر عنصر في الـ object الذي قيمته ليست null
      const entries = Object.entries(filterData);
      let location_type = null;
      let q = null;
      
      // البحث من النهاية للبداية عن أول عنصر قيمته ليست null
      for (let i = entries.length - 1; i >= 0; i--) {
        const [key, value] = entries[i];
        if (value !== null && value !== undefined && value !== '') {
          location_type = key;
          q = value;
          break;
        }
      }
      
      // إضافة المعاملات للـ API
      if (location_type && q) {
        params.append('location_type', location_type);
        params.append('q', q);
      }

      const response = await axios.get(`${baseURL}streams/locations/search?${params.toString()}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      setData(response.data)
      // يمكنك معالجة النتائج هنا حسب احتياجاتك
      // مثلاً تحديث حالة معينة أو عرض النتائج
       setLoading(false);
      enqueueSnackbar("Location search completed successfully", {
        variant: "success",
      });

      return response.data;
    } catch (error) {
      console.error('Location search error:', error);
      enqueueSnackbar("Location search failed: " + error?.message, {
        variant: "error",
      });
       setLoading(false);
    }
  };

  const openFilter = () => {
    setPopup({
      isOpen: true,
      title: "Select Date, Time and Location Filters",
      content: (
        <FilterStream
          ref={childRef}
          filter={filter}
          changeFilterHandle={setFilter}
        />
      ),
      sendReq: async () => {
        // تنفيذ submit الخاص بالفلتر أولاً
        const filterResult = await childRef.current?.submit();
        
        // ثم استدعاء API البحث عن المواقع بناءً على نتائج الفلتر
    
      },
    });
  };
   useEffect(()=>{
     searchLocationsAPI(filter);
   },[filter])
  const openPopup = () => {
    setPopup({
      isOpen: true,
      title: "Remove Stream",
      content: "Are you sure you want to remove those camera streams?",
      sendReq: handelDeleteReqFromApi,
    });
  };

  return (
    <Holder
      title="All Streams"
      action={
        <CustomBtn handle={() => navigate("/streams/add-stream")}>
          Add New Stream
        </CustomBtn>
      }
    >
      <DesBtn text="Filter" handle={openFilter}>
        <FilterAltOutlinedIcon />
      </DesBtn>
      
      <Box my={2}>
        <TableReusable
          selected
          handelChangeSelect={changeSelectDataRow}
          showCheckbox
          data={data}
          columns={streamColumns}
          loading={loading}
        />
      </Box>

      <Stack direction="row" justifyContent="space-between" gap={2}>
        <CustomBtn
          disable={selectedData.length < 1}
          color="error"
          isLined
          handle={openPopup}
        >
          Delete
        </CustomBtn>

        <Stack direction="row" gap={2}>
          <CustomBtn
            disable={selectedData.length < 1}
            isLined
            handle={() => navigate("/streams/update-streams")}
          >
            Update
          </CustomBtn>

          <CustomBtn
            disable={selectedData.length < 1}
            handle={() => navigate("/streams/show-streams")}
          >
            Show Stream
          </CustomBtn>
        </Stack>
      </Stack>
    </Holder>
  );
};

export default Streams;